<!--
<ng-container *ngIf='dataUrl$|async; let dataUrl'>
    <img src='{{ dataUrl }}' alt='{{ fieldValue }}' />
</ng-container>
<div class='hidden-canvas'>
    <canvas #canvasElement></canvas>
</div>
-->
